import { default as EventBus } from './event-bus';

export default {
  install(Vue) {
    Vue.prototype.$eventBus = EventBus;
  },
};
